module.exports = __webpack_public_path__ + "static/media/darkmon.fa6a7b5c.png";